"use strict";

var request = require('./request');
var LanguageAPIUtils = {};

LanguageAPIUtils.setLang = function(data) {
    var language = {data:data}
    return Promise.resolve(language);
};

module.exports = LanguageAPIUtils;



/** WEBPACK FOOTER **
 ** ./modules/utils/LanguageAPIUtils.js
 **/